import React, { useEffect, useState, useRef, useCallback, useMemo } from 'react';
import { Button, Input, InputRed, LayerBottom } from 'components'
import useApp from 'hooks/useApp'
import styles from './index.module.css'
import address from './address'
import useSecureKeypad from 'hooks/useSecureKeypad';
import { useNavigate } from 'react-router-dom';

const GrantSecurity = () => {

	const App = useApp()
	const [showLayer, setShowLayer] = useState(false);
	const [module, showKeypad] = useSecureKeypad();
	const [rsdtFirstNumber, setRsdtFirstNumber] = useState("");
	const [rsdtLastNumber, setRsdtLastNumber] = useState("");
	const [rsdtRestNumber, setRsdtRestNumber] = useState("");
	const [rsdtNumber, setRsdtNumber] = useState();
	const [disabled, setDisabled] = useState(true);
	const [certRedText] = useState("잘못된 주민등록번호에요. 다시 입력해주세요.") // 오류 문구
	const restInput = useRef(null);
	const [socialLength, setSocialLength] = useState(0);
	const [resultAddress, setResultAddress] = useState(null);
	
	const [sidoValue, setSidoValue] = useState("");
	const [sidoNm, setSidoNm] = useState("");
	const [gunguValue, setGunguValue] = useState("");
	const [gunguNm, setGunguNm] = useState("");

	const user = App?.user;
	const navigate = useNavigate();
	const openLayer = () => setShowLayer(true);

	const closeLayer = useCallback(() => {
		setShowLayer(false);
		if (sidoValue === "" && sidoNm === "" && gunguValue === "" && gunguNm === "") return true;
 		setResultAddress({sidoValue, sidoNm, gunguValue, gunguNm});
	}, [sidoValue, sidoNm, gunguValue, gunguNm])

	useEffect(()=>{
		if (user) {
			const brith = user.birthDe.replace(/-/g, "");
			const gender = user.gendr;
			const genderList = ["18", "19", "19", "20", "20", "", "", "", "", "18"];
			const _y = brith.substr(0, 2);
			const _date = brith.substr(2, 6);
			let _g;

			genderList.forEach((gd, index) => {
				if (_y === gd) {
					if (gender === "M") {
						if (index % 2 === 1) {
							setRsdtLastNumber(index)
							_g = index
						}
					} else if (gender === "W") {
						if (index % 2 === 0) {
							setRsdtLastNumber(index)
							_g = index
						}
					}
				}
			})
			setRsdtFirstNumber(_date);
			setRsdtNumber(_date + _g);
		}
	}, [user])

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		});
		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	const onNext = () => {
		var info = module.get_sessionInfo()
		/* const sessionId = info.sessionId;
		const input = info.input;
		const secToken = info.secToken; */
		// 현재 암호화된 주민번호 가지고 하는게 없음
		navigate("/life/certiManage", {
			state: {
				address: resultAddress,
				secureKb: info
			}
		})
	}

	const clickPwInput = (e) => {
		e.target.value = ""
		showKeypad({
			input: e.target,
			onShow: () => {
				setDisabled(true)
			},
			onChange: (length) => {
				//setDisabled(length !== 6)
				setSocialLength(length)
			}
		})
	}

	// #region 주민등록번호 유효성 체크
	useEffect(() => {
		const _check = (ssn) => {
			const compare = [2, 3, 4, 5, 6, 7, 8, 9, 2, 3, 4, 5];
			ssn = ssn.split("");
			let ssnLast = Number(ssn[ssn.length - 1]);
			let sum = 0;
			for (let i = 0; i < ssn.length - 1; i++) {
				sum += ssn[i] * compare[i];
			}
			sum = sum % 11;
			sum = 11 - sum;
			if (sum > 9) {
				sum = sum % 10;
			}
			if (sum !== ssnLast) return false;
			return true;
		}
		const rsdtValidate = () => {
			let ssn = rsdtNumber + rsdtRestNumber;
			console.log( `resultAddress: ${resultAddress}` );
			if (resultAddress === null) return true;
			if (socialLength !== 6) return true;
			//if (ssn.length !== 13) return true;
			//if (!_check(ssn)) return true;
			return false;
		}

		let check = rsdtValidate();
		setDisabled(check);

	}, [rsdtFirstNumber, rsdtLastNumber, rsdtNumber, rsdtRestNumber, resultAddress, socialLength]);

	useEffect(() => {
		console.log(module.isOpen)
	}, [module])

	return (
		<div className="page">
			<div className="flex_1 padding">
				<h3>거주지와 주민등록번호 뒷자리를<br />입력해주세요.</h3>
				<p className="guide-title mt_20">입력한 정보는 정부지원금 추천을 위해서만 사용돼요!</p>

				<p className="guide-title mt_40">거주지</p>
				<div className={`${styles["select-area"]} mt_10`} onClick={openLayer}>
					{!resultAddress
						? <span style={{ color: "#ddd" }}>지역을 선택하세요.</span>
 						: <span>{`${sidoNm} ${gunguNm}`}</span>
					}
					<i className="icon" />
				</div>

				<p className="guide-title mt_40">주민등록번호</p>
				<div className="flex-align_center mt_10">
					<div className="flex--item_1">
						<Input 
							type="text" 
							placeholder="주민번호 앞 6자리" 
							id="" 
							maxlength="6" 
							value={rsdtFirstNumber}
							readOnly
						/>
					</div>
					<span style={{ margin: "0 0.5rem" }}>-</span>
					<div className="form-group flex--item_1">
						{/* 숫자 입력 시 폰트사이즈 3rem */}
						<Input 
							type="password" 
							placeholder="숫자 6자리" 
							id="" 
							maxlength="6"
							ref={restInput}
							style={{ paddingLeft: "2rem", letterSpacing: "1rem", paddingRight: 0 }} 
							onClick={clickPwInput}
						/>
						<span className="number">{rsdtLastNumber}</span>
					</div>
				</div>
				<InputRed text={certRedText} show={socialLength !== 6} />
			</div>

			<div className="flex-shrink_0 padding">
				<Button className="btn btn--big" disabled={disabled} onClick={onNext}>다음</Button>
			</div>

			<SelectLayer 
				show={showLayer}
				closeLayer={closeLayer}
				address={address}
				setSidoValue={setSidoValue}
				setSidoNm={setSidoNm}
				setGunguValue={setGunguValue}
				setGunguNm={setGunguNm} 
			/>
		</div>
	)
}

const SelectLayer = ({ show, closeLayer, address, setSidoValue, setSidoNm, setGunguValue, setGunguNm }) => {
	const [menuOpen, setMenuOpen] = useState(0);
	const [adrsLst, setAdrsLst] = useState(null);
	const mounted = useRef(false);

	const getAddress = (adrs) => {
		const _formatAdrsLst = adrs.sido.map(( sido, index ) => {
			return {
				...sido,
				checked: false, 
				gungu: adrs.gungu[sido.value].map((gu, index) => ({ ...gu, checked: false }))
			}
		});
		setAdrsLst(_formatAdrsLst);
	};

	const onMenuOpenHandler = useCallback((e, index) => {
		e.stopPropagation();
		// const layerContent = document.querySelector(".layerContent");
		// const targetOffsetTop = e.currentTarget.offsetTop;
		// const layerContentHeight = layerContent.scrollHeight;
		// const layerClientHeight = layerContent.clientHeight;
		// console.log( `scrollTop: ${layerContent.scrollTop}` );
		// console.log(`offset top: ${targetOffsetTop}`);
		// console.log(`layerContentHeight: ${layerContentHeight}`);
		// console.log(`layerClientHeight: ${layerClientHeight}`);
		// console.log(`${targetOffsetTop - 72}`);
		
		//document.querySelector(".layerContent").scrollTo(0, `${targetOffsetTop - 72}`);
		setMenuOpen(index);
	}, [])

	const onSidoHandler = useCallback((value, nm, checked, index) => {
		if (!checked){
			setSidoValue(value);
			setSidoNm(nm);
		} else {
			setSidoValue("");
			setSidoNm("");
		}

		setAdrsLst(prevAddress => {
			return prevAddress.map((sido, idx) => {
				return sido.value === value 
					? { 
						...sido, 
						checked: !checked,
					} : {
						...sido, 
						checked: false,
						gungu: prevAddress[idx].gungu.map(gu => {
							return { ...gu, checked: false }
						})
					}
			});
		})
	}, []);

	const onGunguHandler = useCallback((sidoValue, gunguValue, guNm, checked, sidoIndex, gunguIndex)=>{
		if (!checked){
			setGunguValue(gunguValue);
			setGunguNm(guNm);
		} else {
			setGunguValue("");
			setGunguNm("");
		}

		setAdrsLst(prevAddress => {
			return prevAddress.map(sido => {
				return sido.value === sidoValue 
					? {
						...sido,
						gungu: prevAddress[sidoIndex].gungu.map((gu, index) => {
							return gunguIndex === index ? { ...gu, checked: !checked } : { ...gu, checked: false }
						})
					} : sido
					
			});
		});
	}, []);

	useEffect(()=>{
		mounted.current = true;
		mounted.current && getAddress(address);
		return () => mounted.current = false;
	}, []);

	useEffect(()=>{
		if (show) {
			// document.querySelector(".layerContent").addEventListener('scroll', (e) => {
			// 	console.log( e.currentTarget.scrollTop );
			// });
		}
	}, [show])

	return (
		<LayerBottom title="지역 선택" show={show} closeLayer={closeLayer} closeButton={false} outside={
			<Button className="btn btn--big btn-layer" onClick={closeLayer}>확인</Button>
		}>
			{!adrsLst
				? (
					<ul className={`${styles["area-list"]} accordion-list`}>
						<li>
							<div className="flex-justify_between align_center">
								<p className="bold skeleton" style={{ "width": "5rem", "height": "1.8rem" }}>서울</p>
								<i className="icon icon_arrow_sm bottom" />
							</div>
						</li>
						<li>
							<div className="flex-justify_between align_center">
								<p className="bold skeleton" style={{ "width": "5rem", "height": "1.8rem" }}>인천</p>
								<i className="icon icon_arrow_sm bottom" />
							</div>
						</li>
						<li>
							<div className="flex-justify_between align_center">
								<p className="bold skeleton" style={{ "width": "5rem", "height": "1.8rem" }}>대전</p>
								<i className="icon icon_arrow_sm bottom" />
							</div>
						</li>
					</ul>
				) : (
					<ul className={`${styles["area-list"]} accordion-list`}>
						{
							adrsLst.map((item, sidoIndex) =>
								<li key={sidoIndex} className={item.checked ? "active" : ""}>
									<div className="flex-justify_between align_center" onClick={() => onSidoHandler(item.value, item.key, item.checked, sidoIndex)}>
										<p className="bold">{item.key}</p>
										<i className="icon icon_arrow_sm bottom" />
									</div>
									<div className="menu-open mt_20">
										<ul className="menu-select">
											{item.gungu.map((gu, index) => 
												<li key={index} className={gu.checked ? 'on' : ''} onClick={() => onGunguHandler(item.value, gu.value, gu.key, gu.checked, sidoIndex, index)}>{gu.key}</li>
											)}
										</ul>
									</div>
								</li>
							)
						}
					</ul>
				)
			}	
		</LayerBottom>
	)
}

export default GrantSecurity